import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class Tax extends CatalogObjectSerializer {}